export default "__VITE_ASSET__BZGadC3E__"